import React from 'react';
import classNames from 'classnames';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import EnhancedTableHead from '../../utils/EnhancedTableHead';
import { commonTablestyles } from '../../utils/Style';

class UserTable extends React.Component {
    state = {
        open: false,
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            objects: [],
            selected: [],
            order: 'asc',
            orderBy: '',
            page: 0,
        };
    }

    componentWillMount() {
        this.setState({ objects: this.props.objects });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ selected: nextProps.selected });
        //this.setState({ page: nextProps.page });
        if (nextProps != this.state.objects) {
            this.setState({ objects: nextProps.objects });
        }
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const objects =
            order === 'desc'
                ? this.state.objects.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.objects.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({ objects, order, orderBy });
    };

    isRegisterPackageButtonDisabled = (accessibleId) => {
        if (accessibleId != 0) {
            return true;
        } else {
            return false;
        }
    }

    isSelected = id => this.state.selected.indexOf(id) !== -1;

    render() {
        const { classes, columnData, handleChangeRowsPerPage, handleModalOpen, handleChangePage, countuserValue, rowsPerPage, emptyRows, selected, handleClick, handleSelectAllClick } = this.props;
        const { objects, order, orderBy, page } = this.state;
        return (
            <div className={classes.tableWrapper}>
                <Table className = { classes.table } aria-labelledby="tableTitle">
                    <EnhancedTableHead
                        numSelected={selected.length}
                        order={this.state.order}
                        orderBy={this.state.orderBy}
                        onSelectAllClick={(event) => handleSelectAllClick(event, event.target.checked) }
                        onRequestSort={ this.handleRequestSort }
                        rowCount={objects.length}
                        columnData={columnData}
                    />
                    <TableBody>
                        {objects.map(n => {
                            const isSelected = this.isSelected(n.id);
                            return (
                                <TableRow
                                    hover
                                    role="checkbox"
                                    aria-checked={isSelected}
                                    tabIndex={-1}
                                    key={n.id}
                                    selected={isSelected}
                                >
                                    <TableCell padding="checkbox">
                                        <Checkbox checked={isSelected}
                                            onClick={ (event) => handleClick(event, n.id)}
                                        />
                                    </TableCell>
                                    <TableCell component="th" scope="row" padding="none">
                                        {n.username}
                                    </TableCell>
                                    <TableCell>{n.status}</TableCell>
                                    <TableCell numeric>{n.datetime_created}</TableCell>
                                    <TableCell numeric>{n.pw_modified}</TableCell>
                                    <TableCell numeric>{n.lastlogin}</TableCell>
                                    <TableCell numeric>{n.login_ip}</TableCell>
                                    <TableCell>{n.username == 'No result' ? (
                                        <Button disabled variant="flat" color="secondary" className={classes.button} onClick={() => handleModalOpen(n.id, n.username)}>Register Package</Button>
                                    ) : <Button disabled={this.isRegisterPackageButtonDisabled(n.accessibility_user_id)} variant="flat" color="secondary" className={classes.button} onClick={() => handleModalOpen(n.id, n.username)}>Register Package</Button>}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                        {emptyRows > 0 && (
                            <TableRow style={{ height: 49 * emptyRows }}>
                                <TableCell colSpan={6} />
                            </TableRow>
                        )}
                    </TableBody>
                </Table >
            </div>
        );
    }
}

export default withStyles(commonTablestyles)(UserTable);


// WEBPACK FOOTER //
// ./src/utils/MainTable/UserTable.js